module.exports = __webpack_public_path__ + "images/embed/icons/linkedin_icon_dark.png";